import { render, staticRenderFns } from "./PersonGender.vue?vue&type=template&id=30aa11da&scoped=true&"
import script from "./PersonGender.vue?vue&type=script&lang=js&"
export * from "./PersonGender.vue?vue&type=script&lang=js&"
import style0 from "./PersonGender.vue?vue&type=style&index=0&id=30aa11da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa11da",
  null
  
)

component.options.__file = "PersonGender.vue"
export default component.exports